import React, { useEffect } from "react";
import classNames from "classnames/bind";
import styles from "./ButtonToggleGroup.module.scss";
import type { ButtonToggleGroupProps } from "./types";
import { Icon } from "../Icon";
import { Tooltip } from "../Tooltip";

const cx = classNames.bind(styles);

/**
 * A component to allow toggling between various content
 */
const ButtonToggleGroup = ({
  activeKey,
  onChange,
  items,
  value,
  className,
  style,
  isDisabled,
}: ButtonToggleGroupProps) => {
  const activeValue = activeKey || value;

  useEffect(() => {
    if (!activeValue) {
      onChange(items[0].dataKey);
    }
  }, []);

  const onItemClick = (dataKey: string) => {
    onChange(dataKey);
  };

  return (
    <ul
      className={cx("container", className)}
      style={{
        gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))`,
        ...style,
      }}
    >
      {items?.map(
        ({ dataKey, label, description = "", leftSlot, rightSlot }) => (
          <li
            key={dataKey}
            onClick={() => {
              if (!isDisabled) {
                onItemClick(dataKey);
              }
            }}
            className={cx("item", {
              active: activeValue === dataKey,
              disabled: !!isDisabled,
            })}
            aria-current={activeValue === dataKey}
          >
            {leftSlot}
            {label}
            {rightSlot}
            {description ? (
              <Tooltip
                content={description}
                contentClassName={cx("tooltip-icon")}
              >
                <Icon variant="info" />
              </Tooltip>
            ) : null}
          </li>
        )
      )}
    </ul>
  );
};

export default ButtonToggleGroup;
